// extracted by mini-css-extract-plugin
module.exports = {"list":"FooterList_list__HmEvC","item":"FooterList_item__KXNTa"};